// extracted by mini-css-extract-plugin
export default {"root":"CallToAction-root_z_RzQ","emptyPage":"CallToAction-emptyPage_bFN0d","products":"CallToAction-products_rKgYd"};